// Types
import PortfolioHolding from '@/types/portfolio-holding';
import Timestamp from '@/types/timestamp';

export enum AIStatementReaderStatus {
  CANCELLED = 'CANCELLED',
  FAILED = 'FAILED',
  SUCCESS = 'SUCCESS',
}

export type AIStatementReaderState = {
  current: {
    processedFiles: Array<PortfolioHolding>;
    processingCancelled: boolean;
    processingError: boolean;
    activityLogs?: aiStatementReaderActivityLogs;
  };
};

type aiStatementReaderActivityLogs = {
  aiStatementReadStartTime: Timestamp; // the click on continue
  aiStatementReadEndTime: Timestamp; // the request is done
};
